export const BookingFunnelBookableItemType: {
    SERVICE: 'SERVICE',
    BUNDLE: 'BUNDLE',
} = {
    SERVICE: 'SERVICE',
    BUNDLE: 'BUNDLE',
};

export type BookingFunnelBookableItemType = (typeof BookingFunnelBookableItemType)[keyof typeof BookingFunnelBookableItemType];